import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Heading, Flex, Box, Text } from '@qga/roo-ui/components';
import RatingFilterElement from 'components/Filters/Search/RatingFilter/RatingFilterElement/RatingFilterElement';
import FilterContainer from 'components/Filters/FilterContainer';
import TextButton from 'components/TextButton';
import { getQueryMinStarRating } from 'store/router/routerSelectors';

const RATING_TYPE = 'minStarRating';

const StarRatingFilter = ({ onChange, displayClearFilter, onClearFilter }) => {
  const minStarRating = useSelector(getQueryMinStarRating);

  return (
    <Fragment>
      <Flex justifyContent="space-between">
        <Flex flexDirection="column">
          <Heading.h2 fontSize="sm" mb={1}>
            Hotel Rating
          </Heading.h2>
          <Text mb={2}>Includes official and other ratings</Text>
        </Flex>
        {displayClearFilter && (
          <Box>
            <TextButton data-testid="clear-star-button" fontSize="sm" onClick={onClearFilter}>
              Clear
            </TextButton>
          </Box>
        )}
      </Flex>
      <Box mb={[0, displayClearFilter ? 0 : 6]}>
        <FilterContainer data-testid="hotel-rating-filter">
          <RatingFilterElement
            text="5 out of 5 rating"
            rating="5"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="4 out of 5 rating & up"
            rating="4"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="3 out of 5 rating & up"
            rating="3"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="All ratings"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
        </FilterContainer>
      </Box>
    </Fragment>
  );
};

StarRatingFilter.propTypes = {
  minStarRating: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  displayClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

StarRatingFilter.defaultProps = {
  minStarRating: undefined,
  displayClearFilter: false,
  onClearFilter: () => {},
};

export default StarRatingFilter;
